import * as React from 'react';

import { cn } from 'lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Squared, line-strong border, lime focus halo. Background matches
          // --input-bg so the input sits on the surface in dark and on paper
          // in light. file:* keeps file inputs visually consistent.
          'flex h-10 w-full border border-[var(--line-strong)] bg-[var(--input-bg)] px-3.5 py-2.5 text-sm text-[var(--text)] transition-[border-color,box-shadow] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--text-muted)] placeholder:opacity-80 focus-visible:border-[var(--accent)] focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--ring-color)] disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
